import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { CommonModal, CommonButton } from "../Input";
import Swal from "sweetalert2";

const TransactionInformationModal = ({ show, onHide, transaction }) => {
  if (!transaction) return null;
  const userRole = localStorage.getItem("userRole");

  const CustomHeader = () => (
    <div className="w-100 d-flex justify-content-between align-items-center pe-4">
      <h4 className="mb-0 fw-bold text-black" style={{ fontSize: "18px" }}>
        Transaction Details
      </h4>
      <div className="d-flex gap-2">
        <CommonButton
          variant="outline"
          className="py-1 px-3 d-flex align-items-center"
          style={{ fontSize: "12px", height: "36px" }}
        >
          <i className="fas fa-download me-2"></i> Download Receipt
        </CommonButton>
        <CommonButton
          variant="outline"
          className="py-1 px-3 d-flex align-items-center"
          style={{ fontSize: "12px", height: "36px" }}
        >
          <i className="fas fa-print me-2"></i> Print Receipt
        </CommonButton>
        <CommonButton
          variant="outline"
          className="py-1 px-3 d-flex align-items-center"
          style={{ fontSize: "12px", height: "36px" }}
        >
          <i className="far fa-envelope me-2"></i> Email Receipt
        </CommonButton>
      </div>
    </div>
  );

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title="Transaction Details"
      size="xl"
      headerClassName="border-bottom pb-3"
      contentClassName="border-0 shadow-lg"
    >
      <div>
        {/* Sender Section */}
        <div className="fw-bold fs-13 mb-1 text-black">Sender</div>
        <div
          className="p-4 mb-4 border border-light"
          style={{ borderRadius: "12px", backgroundColor: "#FAFAFA" }}
        >
          <Row className="gy-4">
            <Col sm={3} md={2}>
              <div className="text-muted fs-12 mb-1">Customer Type</div>
              <div className="fw-medium text-black fs-13">
                {transaction.details?.customerType || "Organization"}
              </div>
            </Col>
            <Col sm={3} md={2}>
              <div className="text-muted fs-12 mb-1">Sender Name</div>
              <div className="fw-medium text-black fs-13">
                {transaction.senderName || "QC"}
              </div>
            </Col>
            <Col sm={3} md={2}>
              <div className="text-muted fs-12 mb-1">Customer ID</div>
              <div className="fw-medium text-black fs-13">
                {transaction.details?.customerId || "481"}
              </div>
            </Col>
            <Col sm={3} md={2}>
              <div className="text-muted fs-12 mb-1">ID Type</div>
              <div className="fw-medium text-black fs-13">
                {transaction.details?.idType || "NRIC (Citizen)"}
              </div>
            </Col>
            <Col sm={3} md={2}>
              <div className="text-muted fs-12 mb-1">ID Number</div>
              <div className="fw-medium text-black fs-13">
                {transaction.details?.idNumber || "811111111999"}
              </div>
            </Col>
            <Col sm={3} md={2}>
              <div className="text-muted fs-12 mb-1">Payment Method</div>
              <div className="fw-medium text-black fs-13">
                {transaction.paymentMethod || "Cash"}
              </div>
            </Col>
            <Col sm={3} md={2}>
              <div className="text-muted fs-12 mb-1">Bank Transfer Amount</div>
              <div className="fw-medium text-black fs-13">
                {transaction.details?.bankTransferAmount || "0 SGD"}
              </div>
            </Col>
            <Col sm={3} md={2}>
              <div className="text-muted fs-12 mb-1">Cash Amount</div>
              <div className="fw-medium text-black fs-13">
                {transaction.sendAmount || "7.35"}{" "}
                {transaction.currency || "SGD"}
              </div>
            </Col>
          </Row>
        </div>

        {/* Beneficiaries Section */}
        <div className="fw-bold fs-13 mb-1 text-black">Beneficiaries</div>
        <div
          className="p-4 border border-light "
          style={{ borderRadius: "12px", backgroundColor: "#FAFAFA" }}
        >
          <Row className="gy-4">
            {/* Left side info */}
            <Col lg={8}>
              <div className="mb-4">
                <Badge
                  bg="light"
                  className="px-3 py-1 border rounded"
                  style={{
                    fontSize: "11px",
                    color:
                      transaction.statusValue === "waiting_aml"
                        ? "#6941C6"
                        : transaction.statusValue === "waiting_admin"
                          ? "#C66941"
                          : "#41C669",
                    backgroundColor:
                      transaction.statusValue === "waiting_aml"
                        ? "#F4F3FF"
                        : "#FFF4F3",
                    borderColor:
                      transaction.statusValue === "waiting_aml"
                        ? "#D6BBFB"
                        : "#FBD6BB",
                  }}
                >
                  {transaction.status || "Waiting for AML transaction approval"}
                </Badge>
              </div>

              <Row className="gy-4">
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">Transaction ID</div>
                  <div className="d-flex align-items-center">
                    <span className="fw-medium text-black fs-13 me-2">
                      {transaction.id || "100006551"}
                    </span>
                    <i
                      className="far fa-copy text-muted cursor-pointer"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">
                    Created Date & Time
                  </div>
                  <div className="fw-medium text-black fs-13">
                    {transaction.displayDate || "04/03/2026"}{" "}
                    {transaction.time || "09:42:23"}
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">Receiver Name</div>
                  <div className="fw-medium text-black fs-13">
                    {transaction.receiverName || "Nguyen Kieu Hanh"}
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">Receiver Type</div>
                  <div className="fw-medium text-black fs-13">
                    {transaction.details?.receiverType || "Organization"}
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">Receiving Method</div>
                  <div className="fw-medium text-black fs-13">
                    {transaction.details?.receivingMethod || "Bank Transfer"}
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">Bank/Agent</div>
                  <div className="fw-medium text-black fs-13">
                    {transaction.details?.bankAgent || "ASIA UNITED BANK"}
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">Country</div>
                  <div className="fw-medium text-black fs-13">
                    {transaction.details?.country || "Philippines"}
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">Account No/IBAN</div>
                  <div className="d-flex align-items-center">
                    <span className="fw-medium text-black fs-13 me-2">
                      {transaction.details?.accountNoIban || "394589437521"}
                    </span>
                    <i
                      className="far fa-copy text-muted cursor-pointer"
                      style={{ fontSize: "12px" }}
                    ></i>
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">Address</div>
                  <div className="fw-medium text-black fs-13">
                    {transaction.details?.address || "2323"}
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">IFSC Code</div>
                  <div className="fw-medium text-black fs-13">
                    {transaction.details?.ifscCode || "--"}
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">
                    Purpose of Transfer
                  </div>
                  <div className="fw-medium text-black fs-13">
                    {transaction.details?.purposeOfTransfer ||
                      "Supplier/Vendor/Agent Payment"}
                  </div>
                </Col>
                <Col sm={6} md={4}>
                  <div className="text-muted fs-12 mb-1">Source of Funds</div>
                  <div className="fw-medium text-black fs-13">
                    {transaction.details?.sourceOfFunds || "Salary"}
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Right side amounts card */}
            <Col lg={4}>
              <div
                className="rounded-4 border border-1 p-4 h-100 mt-md-0 mt-4 bg-white"
                style={{
                  borderRadius: "12px",
                }}
              >
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted fs-12">Receiving Amount</span>
                  <span className="fw-medium text-black fs-13">
                    {transaction.details?.receivingAmount || "72.9 PHP"}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted fs-12">Exchange Rate</span>
                  <span className="fw-medium text-black fs-13">
                    {transaction.details?.exchangeRate || "1 SGD = 36.45 PHP"}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted fs-12">Send Amount</span>
                  <span className="fw-medium text-black fs-13">
                    {transaction.sendAmount || "2"}{" "}
                    {transaction.currency || "SGD"}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted fs-12">Service Charge</span>
                  <span className="fw-medium text-black fs-13">
                    {transaction.details?.serviceCharge || "5.35 SGD"}
                  </span>
                </div>
                <div className="d-flex justify-content-between mb-4 pb-4 border-bottom">
                  <span className="text-muted fs-12">Promo</span>
                  <span className="fw-medium text-black fs-13">
                    {transaction.details?.promo || "0.00 SGD"}
                  </span>
                </div>
                <div className="d-flex justify-content-between mt-2">
                  <span className="text-muted fs-12">Total Amount</span>
                  <span className="fw-medium text-black fs-13">
                    {transaction.details?.totalAmount || "7.35 SGD"}
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Modal Footer with Actions */}
      <div className="px-4 py-3  bg-white d-flex justify-content-between align-items-center">
        <div></div> {/* Spacer */}
        <div className="d-flex align-items-center gap-3">
          <div className="fw-bold text-black me-3" style={{ fontSize: "18px" }}>
            Total to Pay: {transaction.details?.totalAmount || "7.35 SGD"}
          </div>
          {transaction.statusValue === "waiting_aml" &&
            userRole === "Teller" && (
              <>
                <CommonButton
                  variant="danger"
                  className="px-5 py-2 fw-medium"
                  onClick={() => {
                    Swal.fire({
                      icon: "success",
                      title: "Success",
                      text: "Transaction Rejected Successfully!",
                      confirmButtonColor: "var(--primary)",
                    }).then(() => {
                      onHide();
                    });
                  }}
                >
                  Reject
                </CommonButton>
                <CommonButton
                  className="px-5 py-2 fw-medium"
                  onClick={() => {
                    Swal.fire({
                      icon: "success",
                      title: "Success",
                      text: "Transaction Approved Successfully!",
                      confirmButtonColor: "var(--primary)",
                    }).then(() => {
                      onHide();
                    });
                  }}
                >
                  Approve
                </CommonButton>
              </>
            )}
        </div>
      </div>
    </CommonModal>
  );
};

export default TransactionInformationModal;
